export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'displayImage',
    width: 120,
    title: that.$l('table_label_image') || '图片',
    align: 'center',
    fixed: 'left',
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_displayName') || '产品名称',
    field: 'displayName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 220,
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_displayPlatform') || '渠道产品',
    field: 'displayPlatform',
    headerAlign: 'center',
    align: 'left',
    minWidth: 220,
    showHeaderOverflow: true,
    slots: { default: 'displayPlatform' },
  },
  {
    title: that.$l('table_label_displayPlatformBrand') || '渠道品牌',
    field: 'brandName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_channelSalesPrice') || '结算价格',
    field: 'salesPrice',
    headerAlign: 'center',
    align: 'left',
    minWidth: 100,
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      const { salesPrice, v_salesCurrencyUnit } = row
      return `${that.format(salesPrice) || '0'} ${v_salesCurrencyUnit || ''}`
    },
  },
  {
    title: that.$l('table_label_displayScm') || '生产工厂',
    field: 'displayScm',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayScm' },
  },
  {
    title: that.$l('table_label_displayCategory') || '产品分类',
    field: 'displayCategory',
    width: 200,
    align: 'left',
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      const { masterCategoryName, detailCategoryName } = row
      return [masterCategoryName, detailCategoryName].filter(Boolean).join('/')
    },
  },
  {
    title: that.$l('table_label_inCtnQty') || '装箱入数',
    field: 'inCtnQty',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayBox') || '纸箱',
    field: 'displayBox',
    minWidth: 160,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayBox' },
  },
  {
    title: that.$l('table_label_displayMaterial') || '材料信息',
    field: 'displayMaterial',
    width: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayMaterial' },
  },
  {
    title: that.$l('table_label_goodsProperties') || '产品属性',
    field: 'goodsProperties',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_designName') || '企划人员',
    field: 'designName',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_buyerName') || '采购人员',
    field: 'buyerName',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
  },
]
